import { render, staticRenderFns } from "./errorLayout.vue?vue&type=template&id=1bec569b&scoped=true&"
import script from "./errorLayout.vue?vue&type=script&lang=js&"
export * from "./errorLayout.vue?vue&type=script&lang=js&"
import style0 from "./errorLayout.vue?vue&type=style&index=0&id=1bec569b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec569b",
  null
  
)

export default component.exports